import Title from './title'
import StudioPhotos from 'components/pages/studio-id/photos'

export default function Photo({ studio }) {
  const t = useI18n()
  return (
    <div className='px-5'>
      <Title>{t('page:joinUs.studios.photo')}</Title>
      <div className='h-4'/>
      <StudioPhotos studio={ studio } />
    </div>
  )
}
